import type { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CdkDrag, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import type { TemplateRef, TrackByFunction } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';
import type { AbstractControl, UntypedFormArray, UntypedFormControl } from '@angular/forms';

import type { IconName } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

import { CandidateProfileInformationEditorGroupEntryComponent } from '../candidate-profile-information-editor-group-entry/candidate-profile-information-editor-group-entry.component';

@Component({
  selector: 'rt-candidate-profile-information-editor-group',
  styleUrls: ['./candidate-information-editor-group.component.less'],
  templateUrl: './candidate-information-editor-group.component.html',
  host: {
    '[class.editing]': 'editing()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadingComponent,
    IconComponent,
    CdkDropList,
    CandidateProfileInformationEditorGroupEntryComponent,
    CdkDrag,
    IconButtonComponent,
    CdkDragHandle,
    ButtonComponent,
  ],
})
export class CandidateInformationEditorGroupComponent {
  public readonly editing = input<boolean>(undefined!);
  public readonly showAddButton = input<boolean>(undefined!);
  public readonly parent = input<UntypedFormArray>(undefined!);
  public readonly icon = input<IconName>(undefined!);
  public readonly label = input<string>(undefined!);
  public readonly addLabel = input<string>(undefined!);
  public readonly placeholder = input<string>(undefined!);
  public readonly focusedControl = input<AbstractControl>(undefined!);
  public readonly previewTpl = input<TemplateRef<any>>(undefined!);
  public readonly editPhoneNumber = input<boolean>(false);
  public readonly countryCode = input<string | null>(undefined!);
  @Input() public serverError: string = '';

  public blur = output<AbstractControl>();
  public addControl = output<void>();
  public removeControl = output<number>();
  public reorderControl = output<void>();

  public trackByControl: TrackByFunction<UntypedFormControl> = (
    index: number,
    control: UntypedFormControl,
  ): UntypedFormControl => control;

  public onDrop(event: CdkDragDrop<UntypedFormControl>, controls: AbstractControl[]) {
    const { previousIndex, currentIndex } = event;

    moveItemInArray(controls, previousIndex, currentIndex);
    this.reorderControl.emit();
  }

  public get isReorderEnabled(): boolean {
    return this.parent().length > 1 && this.editing();
  }
}
